var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('singleslider'),_c('brandarea'),_c('section',[_c('selectioncontainer')],1),_c('section',[_c('midbanner',{attrs:{"lists":_vm.bannerlist.result3}}),_c('hotauctions')],1),_c('vechTypeSlider'),_c('midbanner',{attrs:{"lists":_vm.bannerlist.result7}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }